/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable no-alert */
/* eslint-disable jsx-a11y/aria-role */
import _ from 'lodash';
import React from 'react';
import data from './data';
import CanDrag from './CanDrag';
import CanDrop from './CanDrop';

const drag = (items) => items.filter(x => x.text.includes('Drag')).map(x => ({ ...x, canDrag: x.canDrag ?? true }));
const drop = (items) => items.filter(x => x.text.includes('Drop')).map(x => ({ ...x, canDrag: x.canDrag ?? false }));

const DragDrop = props => {
  const [dragItems, setDragItems] = React.useState(drag(data));
  const [dropItems, setDropItems] = React.useState(drop(data));

  const onEndDrag = (item, monitor) => {
    const dropResult = monitor.getDropResult();
    if (!dropResult) return null;
    const { dropItem } = dropResult;
    const { dragItem } = item;
    const from = data.findIndex(x => x.text === dragItem.text);
    _.assign(data[from], { ...data[from], image: dropItem?.image, canDrag: dropItem?.image ?? false });

    const to = data.findIndex(x => x.text === dropItem.text);
    _.assign(data[to], { ...data[to], image: dragItem.image, canDrag: dragItem?.canDrag ?? true });

    setDragItems(drag(data));
    setDropItems(drop(data));
    return true;
  };

  const renderItem = (item) => {
    return (
      <div key={item.text} style={{ margin: 5 }}>
        <CanDrop dropItem={item}>
          <CanDrag dragItem={item} onEndDrag={onEndDrag} canDrag={item.canDrag}>
            <div style={{ width: 50, height: 50, padding: 10 }}>
              {item.image && <img src={item.image} alt="img" style={{ width: '100%', height: '100%' }} />}
            </div>
          </CanDrag>
        </CanDrop>
      </div>
    );
  };

  return (
    <div>
      <div className='d-flex'>
        {dragItems.map(renderItem)}
      </div>
      <div className='d-flex'>
        {dropItems.map(renderItem)}
      </div>
    </div>
  );
};

DragDrop.propTypes = {

};

export default DragDrop;
